import {Pipe, PipeTransform, Inject, LOCALE_ID} from '@angular/core';
import {formatNumber, getLocaleNumberSymbol, NumberSymbol} from '@angular/common';

const PADDING = '000000';

@Pipe({name: 'terraNumber'})
export class TerraNumberPipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor(@Inject(LOCALE_ID) public locale: string) {
    locale = locale || 'en-US';
    this.DECIMAL_SEPARATOR = getLocaleNumberSymbol(locale, NumberSymbol.Decimal);
    this.THOUSANDS_SEPARATOR = getLocaleNumberSymbol(locale, NumberSymbol.Group);
  }

  // Returns a string of the number, with commas
  transform(value: number | string, fractionSize: number = 2): string {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const x = formatNumber(this.parse(value.toString()), this.locale, '1.0-' + fractionSize);
    return x;
  }

  // Returns a string of the number, with NO commas
  parse(value: string | number, fractionSize: number = 2): number {
    if (!value || value === '' || value === null || value === undefined) {
      return null;
    }

    if (typeof value !== 'number' && typeof value !== 'string') {
      throw new Error('TerraNumberPipe parsing error. Value must be of type number or string. Provided value type: ' + (typeof value));
    }

    if (typeof value === 'number') {
      return Number(value);
    }

    const isNegative = value.indexOf('-') === 0;
    if (isNegative) {
      value = value.substring(1);
    }
    value = value.replace(/\-/g, "");

    let [integer, fraction = ''] = (value.toString() || '').split(this.DECIMAL_SEPARATOR);

    if (integer && integer.length) {
      integer = integer.trim();
    }

    const nonNumberAndLeadingZero = new RegExp(`^0+|[^0-9${this.DECIMAL_SEPARATOR}]`, 'g');
    const nonNumber = new RegExp(`[^0-9${this.DECIMAL_SEPARATOR}]`, 'g');
    // if the value is only a fraction (like 0.5), preserve the leading 0
    if (fraction) {
      integer = (+('0' + integer.replace(nonNumberAndLeadingZero, ''))).toString();
      fraction = fraction.replace(nonNumber, '');
    } else {
      integer = integer.replace(nonNumberAndLeadingZero, '').toString();
    }

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize) : '';

    return +(integer + fraction) * (isNegative ? (-1) : 1);
  }
}
